"use client";
import { useLegalModal } from "@/context/LegalModalContext";
import { useLanguage } from "@/context/LanguageContext";
import { useTenant } from "@/context/TenantContext";
import styles from "./LegalModal.module.scss";

function renderContent(text: string) {
  return text.split("\n").map((line, i) => {
    const trimmed = line.trim();
    if (!trimmed) return <div key={i} className={styles.spacer} />;
    if (/^\d+\.\s+[A-Z]/.test(trimmed) || /^[A-Z][A-Z\s&—\-]+$/.test(trimmed)) {
      return <div key={i} className={styles.sectionHeading}>{trimmed}</div>;
    }
    return <div key={i} className={styles.line}>{trimmed}</div>;
  });
}

export default function LegalModal() {
  const { modalType, closeModal } = useLegalModal();
  const { t } = useLanguage();
  const { activeLegalDocs } = useTenant();

  if (!modalType) return null;

  const fallbackTitle: Record<string, string> = {
    privacy: t("legal.privacyTitle"),
    terms: t("legal.termsTitle"),
    security: t("legal.securityTitle"),
  };
  const fallbackContent: Record<string, string> = {
    privacy: t("legal.privacyContent"),
    terms: t("legal.termsContent"),
    security: t("legal.securityContent"),
  };

  const liveDoc = activeLegalDocs?.[modalType];
  const title = liveDoc?.title || fallbackTitle[modalType];
  const content = liveDoc?.content || fallbackContent[modalType];
  const version = liveDoc?.version;

  return (
    <div className={styles.overlay} onClick={closeModal}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>{title}</h2>
          {version && <span className={styles.versionBadge}>v{version}</span>}
        </div>
        <div className={styles.text}>{renderContent(content)}</div>
        <button onClick={closeModal}>{t("legal.ok")}</button>
      </div>
    </div>
  );
}
